export default function () {
  return [
    {
      path: '/publish',
      name: 'Publish',
      component: () => import(/* webpackChunkName: 'publish' */ '@views/publish/index/index.vue'),
      meta: {
        needLogin: false,
        title: 'publish'
      }
    },
    {
      path: '/tags',
      name: 'Tags',
      component: () => import(/* webpackChunkName: 'publish' */ '@views/publish/tags/index.vue'),
      meta: {
        needLogin: false,
        title: 'tags'
      }
    },
    {
      path: '/videoPreview',
      name: 'VideoPreview',
      component: () => import(/* webpackChunkName: 'publish' */ '@views/publish/videoPreview/index.vue'),
      meta: {
        needLogin: false,
        title: 'videoPreview'
      }
    }
  ];
}
